import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './../api/api.service';
import { BackendStorage } from './backend.models';
import { of } from 'rxjs';
import { OfflineDomainService } from 'src/app/shared/utils/offline/services/offline-domain.service';

@Injectable({
  providedIn: 'root',
})
export class BackendService {
  private getRootRoute = () => `${this.apiService.getRoot()}/backend`;
  private getStorageRoute = () => `${this.getRootRoute()}/storage`;

  constructor(
    private readonly apiService: ApiService,
    private readonly httpClient: HttpClient,
    private readonly offlineDomainService: OfflineDomainService
  ) {}

  getStorage = () => {
    return this.offlineDomainService.vm.activated()
      ? of({ used: '-', available: '-', percentage: '-' })
      : this.httpClient.get<BackendStorage>(this.getStorageRoute());
  };
}
